import { Constants } from '../../internal/Constants';
import { SharedHeader } from '../shared/SharedHeader';
import { useNavigate } from 'react-router-dom';

/**
 * Sticky header for the About page. Delegates to the shared header with `homeStyle` disabled.
 *
 * @returns The header element.
 */
export function AboutHeader() {
  const navigate = useNavigate();
  const goToLanding = () => navigate(Constants.Route.Landing);

  return <SharedHeader homeStyle={false} onLogo={goToLanding} onGetStarted={goToLanding} />;
}
